import React from "react";
import type { CashierExpiredPrompt } from "./cashierExpiredError";
import "./CashierStyle.css";

export interface CashierPayBlockedPanelProps {
  prompt: CashierExpiredPrompt;
  onBack?: () => void;
}

export const CashierPayBlockedPanel: React.FC<CashierPayBlockedPanelProps> = ({
  prompt,
  onBack,
}) => (
  <div className="cashier-pay-blocked" role="alert">
    <p className="cashier-pay-blocked-title">{prompt.title}</p>
    <p className="cashier-pay-blocked-desc">{prompt.description}</p>
    {onBack ? (
      <button type="button" className="cashier-pay-blocked-btn" onClick={onBack}>
        返回商户
      </button>
    ) : null}
  </div>
);
